/**
 * Uses the above constant to convert front-end data into format back-end can use
 *
 * @method frontToBack
 * @param {Object} frontEndData Data to convert
 * @returns {Object} Converted data
 */
export const frontToBack = (frontEndData) => ({
    securityQuestionId: parseInt(frontEndData.securityQuestion, 10),
    securityAnswer: frontEndData.securityAnswer,
    password: frontEndData.password
});
/**
 * Uses the above constant to convert front-end data into format back-end can use
 *
 * @method credFrontToBack
 * @param {Object} frontEndValue Data to convert
 * @param {String} frontEndRecaptcha
 * @returns {Object} Converted data
 */
export const credFrontToBack = (frontEndValue, frontEndRecaptcha) => {
    const mappedvalue = {
        username: frontEndValue.username,
        password: frontEndValue.password,
        captchaResponse: frontEndRecaptcha
    };
    return mappedvalue;
};
/**
 * Uses the above constant to convert front-end data into format back-end can use for changing passwords
 *
 * @method passwordChangeFrontToBack
 * @param {Object} frontEndData Data to convert
 * @returns {Object} Converted data
 */
export const passwordChangeFrontToBack = (frontEndData) => ({
    newPassword: frontEndData.passwordNew,
    oldPassword: frontEndData.passwordOld,
    answer: {
        questionId: parseInt(frontEndData.securityQuestion, 10),
        answer: frontEndData.securityAnswer
    }
});
/**
 * Uses the above constant to convert front-end data into format back-end can use for password reset
 *
 * @method passwordResetFrontToBack
 * @param {Object} frontEndValue Data to convert
 * @param {String} frontEndUserId Current user's' ID
 * @param {String} frontEndToken Security token
 * @param {String} frontEndCaptchaResponse Captcha response
 * @returns {Object} Converted data
 */
export const passwordResetFrontToBack = (frontEndValue, frontEndUserId, frontEndToken, frontEndCaptchaResponse) => ({
    userId: frontEndUserId,
    resetToken: frontEndToken,
    securityAnswer: frontEndValue.securityAnswer,
    password: frontEndValue.password,
    captchaResponse: frontEndCaptchaResponse
});
/**
 * Uses the above constant to convert front-end data into format back-end can use for forgotten passwords
 *
 * @method passwordForgotFrontToBack
 * @param {String} frontEndEmail Data to convert
 * @returns {Object} Converted data
 */
export const passwordForgotFrontToBack = (frontEndEmail) => ({
    emailAddress: frontEndEmail
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/auth/dataConversion.ts